import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=1f482080&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=1f482080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f482080",
  null
  
)

export default component.exports